
import { Component, Mixins } from 'vue-property-decorator';
import { VueClass } from 'vue-class-component/lib/declarations';
import { AxVuetify } from '@/mixins';

import * as V from 'vuetify/lib';

const Base = V.VCheckbox as VueClass<unknown>;

@Component
export default class VSelect extends Mixins(Base, AxVuetify) {
  filled!: boolean;
  outlined!: boolean;

  created() {
    Object.defineProperty(this, 'classes', {
      get: () => {
        return {
          ...this.baseClasses
        };
      }
    });
  }
}
